<script lang="ts">
	import { Sidebar, SidebarWrapper, SidebarGroup, SidebarItem, Heading, P } from 'flowbite-svelte';
	import Router, { push, location } from '../svelte-spa-router';
	import { Icon } from 'flowbite-svelte-icons';
	import { isAuthorized } from '../AbstractID';
	import AbstractID from '../AbstractID';
	import settingsRoutes from './settings/routes';
	import site from '../site';
	import PageHeader from '../components/PageHeader.svelte';

	// NOTE: We need to export `params` to allow the SPA router to get the value
	export let params: any = {};
	// NOTE: silence warning
	params = params;

	let activeUrl: string = '';
	let activeSecondLevelUrl: string = '';
	$: {
		activeUrl = $location;
		activeSecondLevelUrl = activeUrl;
		if (activeSecondLevelUrl.startsWith('/Admin/Settings/Admin')) {
			activeSecondLevelUrl = '/Admin/Settings/Admin';
		}
	}

	const fnNavigate = (event: Event, href: string) => {
		event.preventDefault();
		push(href);
	};
</script>

<PageHeader
	title="Settings"
	description="Manage and adjust the {site.name} settings."
/>

<div class="lg:flex mt-10">
	<Sidebar asideClass="lg:w-52 flex-none" activeUrl={activeSecondLevelUrl}>
		{@const iconClass = "w-5 h-5 text-gray-500 transition duration-75 dark:text-gray-400 group-hover:text-gray-900 dark:group-hover:text-white"}
		<SidebarWrapper divClass="overflow-y-auto py-4 px-3 rounded-2xl shadow-md border border-gray-200 dark:border-gray-700 bg-zinc-50 dark:bg-zinc-800">
			<SidebarGroup>
				{@const hrefAccount = '/Admin/Settings/Account'}
				{@const hrefAdmin = '/Admin/Settings/Admin'}

				<SidebarItem label="Account" href={hrefAccount} on:click={(event) => fnNavigate(event, hrefAccount)}>
					<svelte:fragment slot="icon">
						<Icon name="user-outline" class={iconClass} />
					</svelte:fragment>
				</SidebarItem>

				{#if $isAuthorized && AbstractID.isAdministrator}
					<SidebarItem label="Admin" href={hrefAdmin} on:click={(event) => fnNavigate(event, hrefAdmin)}>
						<svelte:fragment slot="icon">
							<Icon name="cog-outline" class={iconClass} />
						</svelte:fragment>
					</SidebarItem>
				{/if}
			</SidebarGroup>
		</SidebarWrapper>

		{#if $isAuthorized && AbstractID.isAdministrator && activeUrl.startsWith('/Admin/Settings/Admin')}
			<Sidebar asideClass="lg:w-52 flex-none" {activeUrl}>
				<SidebarWrapper divClass="overflow-y-auto py-4 px-3 rounded-2xl shadow-md border border-gray-200 dark:border-gray-700 bg-zinc-50 dark:bg-zinc-800 mt-4">
					<SidebarGroup>
						{@const hrefAdmin = '/Admin/Settings/Admin'}
						{@const hrefLogs = '/Admin/Settings/Admin/Logs'}

						<SidebarItem label="Overview" href={hrefAdmin} on:click={(event) => fnNavigate(event, hrefAdmin)}>
							<svelte:fragment slot="icon">
								<Icon name="cog-outline" class={iconClass} />
							</svelte:fragment>
						</SidebarItem>

						<SidebarItem label="Audit Logs" href={hrefLogs} on:click={(event) => fnNavigate(event, hrefLogs)}>
							<svelte:fragment slot="icon">
								<Icon name="list-outline" class={iconClass} />
							</svelte:fragment>
						</SidebarItem>
					</SidebarGroup>
				</SidebarWrapper>
			</Sidebar>
		{/if}
	</Sidebar>
	<div class="lg:ml-10 lg:mt-0 mt-10 w-full">
		<Router routes={settingsRoutes} />
	</div>
</div>
